import { render, staticRenderFns } from "./HomePeriodRecordsDialog.vue?vue&type=template&id=6630074a&scoped=true"
import script from "./HomePeriodRecordsDialog.vue?vue&type=script&lang=js"
export * from "./HomePeriodRecordsDialog.vue?vue&type=script&lang=js"
import style0 from "./HomePeriodRecordsDialog.vue?vue&type=style&index=0&id=6630074a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6630074a",
  null
  
)

export default component.exports